import baseFetch, { doFetchWithOptions } from '../baseFetch';

export const fetchUserDetails = () => baseFetch('user?');

export const fetchUserEntitlements = () => baseFetch('entitlements?');

export const fetchUserFavorites = userDetails => baseFetch('api/v1/user/favorites?', userDetails);

export const fetchUserSettings = (countryCode = 'US') =>
    baseFetch(`user/Settings?geoCountryIso=${countryCode}`);

export const updateUserSettings = update => doFetchWithOptions('user/settings?', {
  method: 'PUT',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(update),
});

export const fetchPaymentWarnings = () => baseFetch('subscriptions/warnings?');



// WEBPACK FOOTER //
// ./src/common/api/user.js